"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const createUnitDetailTitle = (name, accomomdationName, accommodationPageIsPublic) => accommodationPageIsPublic ? `${accomomdationName} - ${name}` : `${name}`;
var _default = exports.default = createUnitDetailTitle;